import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SHARED_LIB_CONFIG, SharedLibConfig } from '../config/lib-config';

@Injectable({
  providedIn: 'root',
})
export class ImageService {
  private pathApi: string;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient, @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig) {
    this.pathApi = this.config.pathApi + 'image/';
  }

  getAddress(obj: { latitude: number; longitude: number }): Observable<any> {
    return this.http.post(`${this.pathApi}getAddress`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }
}
